import React from "react";
import { Modal, Button } from "antd";
import { DeleteOutlined, CloseOutlined } from "@ant-design/icons";

export type DeleteCategoryModalProps = {
  open: boolean;
  categoryName?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DeleteCategoryModal: React.FC<DeleteCategoryModalProps> = ({
  open,
  categoryName,
  loading = false,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={520}
      destroyOnClose
      className="delete-category-modal modal-round"
      closeIcon={<CloseOutlined className="delete-category-close-icon" />}
    >
      <div className="delete-category-hero">
        <div className="delete-category-hero-icon">
          <DeleteOutlined />
        </div>
        <div className="delete-category-hero-wave" />
      </div>

      <div className="delete-category-content">
        <div className="delete-category-title">Delete Category</div>
        <div className="delete-category-subtitle">
          Are you sure you want to delete this category
          {categoryName ? ` (${categoryName})` : ""}?
          <br />
          This action cannot be undone.
        </div>

        <Button
          type="primary"
          danger
          size="large"
          className="delete-category-btn"
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteCategoryModal;
